module.exports = __webpack_public_path__ + "images/banners/jmty_lead/banner_pc_76b0524b08abe8ac4aed49e4d353c66f.jpg";